<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<section class="parent px-2 px-md-6 px-lg-8">
    <div class="parent__container px-3">
        <div class="parent__container__top d-flex flex-column py-2 pt-4">
            <div class="d-flex flex-row justify-content-between">
                <h1
                    class="parent__container__top__title mb-0"
                    [ngClass]="{
                        'big-text':
                            reservationDetails?.data?.reservationDetails
                                ?.status === 'PAID',
                        canceled:
                            reservationDetails?.data?.reservationDetails
                                ?.status === 'CANCELED'
                    }"
                    *ngIf="!cancelationResponse"
                >
                    {{ getStatusText() | translate }}
                </h1>
                <a
                    *ngIf="
                        (this.reservationDetails?.data?.reservationDetails
                            ?.status === 'PRECHECKIN' ||
                            this.reservationDetails?.data?.reservationDetails
                                ?.status === 'REJECTED' ||
                            this.reservationDetails?.data?.reservationDetails
                                ?.status === 'PAID') &&
                        cancelationResponse === null
                    "
                    class="d-flex align-items-center"
                    (click)="printPage()"
                    style="cursor: pointer"
                    ><span
                        class="parent__container__top__print d-none d-md-block mx-2"
                        >{{
                            'fe_details_step5_delivery_cancel_parent_top_print'
                                | translate
                        }}</span
                    >
                    <img
                        class="mx-2"
                        [src]="'images/print.png' | cdn"
                        alt="printer icon"
                /></a>
            </div>
            <h3
                class="parent__container__top__info mt-1"
                *ngIf="
                    (this.reservationDetails?.data?.reservationDetails
                        ?.status === 'CONFIRMED' ||
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'PAID' ||
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'REJECTED' ||
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'PENDING') &&
                    cancelationResponse === null
                "
            >
                {{
                    'fe_details_step5_delivery_cancel_parent_top_info_confirmed'
                        | translate
                }}
            </h3>
            <div
                class="parent__container__top__notice mt-2"
                *ngIf="
                    this.reservationDetails?.data?.reservationDetails
                        ?.status === 'REJECTED' && cancelationResponse === null
                "
            >
                <svg
                    class="parent__container__top__notice__icon"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                >
                    <circle
                        cx="12"
                        cy="12"
                        r="10.2"
                        fill="none"
                        stroke="#FEF100"
                        stroke-width="1.8"
                    />
                    <path
                        d="M12 6.6v6.2M12 16.4h.01"
                        fill="none"
                        stroke="#FEF100"
                        stroke-width="1.9"
                        stroke-linecap="round"
                    />
                </svg>
                <p class="parent__container__top__notice__text mb-0">
                    <b>{{
                        'fe_details_step5_delivery_cancel_parent_top_chip_rejected'
                            | translate
                    }}</b>
                    {{
                        'fe_details_step5_delivery_cancel_parent_top_info_rejected'
                            | translate
                    }}
                </p>
            </div>
            <h3
                class="parent__container__top__info mt-1"
                [ngClass]="{
                    'd-none d-md-block':
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'REJECTED'
                }"
                *ngIf="
                    (this.reservationDetails?.data?.reservationDetails
                        ?.status === 'PRECHECKIN' ||
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'REJECTED' ||
                        this.reservationDetails?.data?.reservationDetails
                            ?.status === 'PAID') &&
                    cancelationResponse === null
                "
            >
                {{
                    'fe_details_step5_delivery_cancel_parent_top_info_precheckin'
                        | translate
                        | replace
                            : {
                                  name: reservationDetails?.data
                                      ?.reservationDetails?.renter?.fullName,
                                  email: reservationDetails?.data
                                      ?.reservationDetails?.renter?.email
                              }
                }}
            </h3>
            <h2
                class="parent__container__top__title canceled"
                *ngIf="cancelationResponse"
            >
                {{
                    'fe_details_step5_delivery_cancel_parent_top_title_canceled'
                        | translate
                }}
            </h2>
            <h2 class="parent__container__top__subtitle">
                {{
                    'fe_details_step5_delivery_cancel_parent_top_subtitle'
                        | translate
                        | replace
                            : {
                                  reservationCode: id
                              }
                }}
            </h2>
            <h3
                class="parent__container__top__info mt-1"
                *ngIf="cancelationResponse !== null"
            >
                {{
                    'fe_details_step5_delivery_cancel_parent_top_info'
                        | translate
                        | replace
                            : {
                                  cancelationDate:
                                      (cancelationResponse.data?.cancelationDate
                                      | date: 'dd MMM yyyy, hh:mm aa'
                                      | titlecase)
                              }
                }}
                <a
                    [routerLink]="'contact-us-and-faqs' | formatUrl"
                    class="parent__container__top__info__extra"
                    >{{
                        'fe_details_step5_delivery_cancel_parent_top_info_extra'
                            | translate
                    }}</a
                >
            </h3>
            <h3
                class="parent__container__top__info mt-1"
                *ngIf="
                    reservationDetails?.data?.reservationDetails
                        ?.cancelationDate !== null &&
                    this.reservationDetails?.data?.reservationDetails
                        ?.status === 'CANCELED'
                "
            >
                {{
                    'fe_details_step5_delivery_cancel_parent_top_info'
                        | translate
                        | replace
                            : {
                                  cancelationDate:
                                      reservationDetails?.data
                                          ?.reservationDetails?.cancelationDate
                                      | date: 'dd MMM yyyy, hh:mm aa'
                                      | titlecase
                              }
                }}
                <a
                    [routerLink]="'contact-us-and-faqs' | formatUrl"
                    class="parent__container__top__info__extra"
                    >{{
                        'fe_details_step5_delivery_cancel_parent_top_info_extra'
                            | translate
                    }}</a
                >
            </h3>
        </div>
    </div>
</section>
